module.exports = __webpack_public_path__ + "f7c0fbf9f187ce634760a2c2c6421257.svg";